import Boa from './boa.svg';
import CapitalOne from './capital_one.svg';
import ChaseBank from './chase_bank.svg';
import CitiBank from './citi_bank.svg';
import PNCBank from './pnc_bank.svg';
import WellsFargo from './wells_fargo.svg';
import TDBank from './td_bank.svg';

const institutionIcons = {
  boa: Boa,
  capital_one: CapitalOne,
  chase_bank: ChaseBank,
  citi_bank: CitiBank,
  pnc_bank: PNCBank,
  wells_fargo: WellsFargo,
  td_bank: TDBank,
};

export default institutionIcons;
